var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.8125 14.1194H4.5625V13.3694H3.8125V14.1194ZM4.64644 16.5259L4.14553 15.9677L4.14553 15.9677L4.64644 16.5259ZM7.32809 14.1194V13.3694H7.04091L6.82717 13.5612L7.32809 14.1194ZM1.75 2.5C1.75 2.36193 1.86193 2.25 2 2.25V0.75C1.0335 0.75 0.25 1.5335 0.25 2.5H1.75ZM1.75 13.1194V2.5H0.25V13.1194H1.75ZM2 13.3694C1.86193 13.3694 1.75 13.2575 1.75 13.1194H0.25C0.25 14.0859 1.0335 14.8694 2 14.8694V13.3694ZM3.8125 13.3694H2V14.8694H3.8125V13.3694ZM4.5625 16.1538V14.1194H3.0625V16.1538H4.5625ZM4.14553 15.9677C4.30649 15.8232 4.5625 15.9375 4.5625 16.1538H3.0625C3.0625 17.2351 4.34255 17.8063 5.14736 17.0841L4.14553 15.9677ZM6.82717 13.5612L4.14553 15.9677L5.14736 17.0841L7.829 14.6776L6.82717 13.5612ZM15 13.3694H7.32809V14.8694H15V13.3694ZM15.25 13.1194C15.25 13.2575 15.1381 13.3694 15 13.3694V14.8694C15.9665 14.8694 16.75 14.0859 16.75 13.1194H15.25ZM15.25 2.5V13.1194H16.75V2.5H15.25ZM15 2.25C15.1381 2.25 15.25 2.36193 15.25 2.5H16.75C16.75 1.5335 15.9665 0.75 15 0.75V2.25ZM2 2.25H15V0.75H2V2.25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 5.875H8.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 9.625H12.25",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMessage);
export default __webpack_public_path__ + "static/media/ic_message.ebe431c0c7c6df373669da908973c938.svg";
export { ForwardRef as ReactComponent };